import { render, staticRenderFns } from "./gameHall.vue?vue&type=template&id=080c4077&scoped=true"
import script from "./gameHall.vue?vue&type=script&lang=js"
export * from "./gameHall.vue?vue&type=script&lang=js"
import style0 from "./gameHall.vue?vue&type=style&index=0&id=080c4077&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c4077",
  null
  
)

export default component.exports